"use strict";

exports.__esModule = true;
var _UserSelector = require("./UserSelector");
Object.keys(_UserSelector).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _UserSelector[key]) return;
  exports[key] = _UserSelector[key];
});